import { Icon } from '@dcc-erp/ui';

// Bulk-action bar for the /ar invoice table. Rendered above the table whenever
// at least one row is selected. Bulk receipt is gated on a single-customer
// selection (a receipt is customer-scoped), so the button disables with a
// title hint when the selection spans more than one customer. Plain
// prototype.css (btn / btn ghost / btn primary) only — no tailwind.

export interface BulkBarProps {
  count: number;
  singleCustomer: boolean;
  onExport: () => void;
  onReceive: () => void;
  onClear: () => void;
}

export function BulkBar({ count, singleCustomer, onExport, onReceive, onClear }: BulkBarProps) {
  if (count <= 0) return null;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '8px 12px',
        marginBottom: 8,
        borderRadius: 8,
        background: 'var(--brand-tint)',
        fontSize: 14,
      }}
    >
      <span className="muted">เลือก {count} รายการ</span>
      <span style={{ flex: 1 }} />
      <button type="button" className="btn" onClick={onExport}>
        <Icon name="download" size={14} /> ส่งออกที่เลือก
      </button>
      <button
        type="button"
        className="btn primary"
        onClick={onReceive}
        disabled={!singleCustomer}
        title={singleCustomer ? undefined : 'เลือกใบแจ้งหนี้ของลูกค้ารายเดียวเพื่อรับชำระ'}
      >
        <Icon name="ar" size={14} /> รับชำระที่เลือก
      </button>
      <button type="button" className="btn ghost" onClick={onClear}>
        <Icon name="x" size={14} /> ล้าง
      </button>
    </div>
  );
}
